import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export default function luckyWinnerRewardsModel() {
  const createRewards = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/CreateRewards",
    method: "POST",
    xRequest: "",
    payload: {
        CampaignId: "",
        RoundId: "",
        RewardsName: "",
        Amount: 0,
        Ref: ""
    },
  });

  const editRewards = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/EditRewards",
    method: "POST",
    xRequest: "",
    payload: {
        Id: "",
        CampaignId: "",
        RoundId: "",
        RewardsName: "",
        Amount: 0,
        Ref: "",
        Status: false
    },
  });

  const fetchRewardsListByCampaign = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/RewardsListByCampaign",
    method: "GET",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      CampaignId: null
    },
  });

  const fetchRewardsListByRound = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/RewardsListByRound",
    method: "GET",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
      CampaignId: null,
      RoundId: null
    },
  });

  const createDuplicateRewards = reactive({
    api: apiEndpoint.bcrm_platform + "/LuckyWinner/CreateRewards",
    method: "POST",
    xRequest: "",
    payload: {
        CampaignId: "",
        RoundId: "",
        RewardsName: "",
        Amount: 0
    },
  });

  return {
    createRewards,
    editRewards,
    fetchRewardsListByCampaign,
    fetchRewardsListByRound,
    createDuplicateRewards
  };
}